// @flow

import * as React from 'react';
import type { Node } from 'react';

import { useEffect } from 'react';

import BasicLayout from 'layouts/Basic';

import Title from 'components/Title';
import Button from 'components/Button';
import './style.scss';

import BasicInfoImg from 'assets/jpg/basic-info.png';
import MainGoalImg from 'assets/jpg/main-goal.png';
import PartialGoalsImg from 'assets/jpg/partial-goals.png';
import FeedImg from 'assets/jpg/feed.png';
import PublishNewImg from 'assets/jpg/publish-new.png';

// import CharcoUpdate from 'assets/svg/Charco/Illustrations/Update.png';
import ProfilePicture from 'assets/profilePic.jpg';
import { ReactComponent as Man } from 'assets/svg/hiker-man-colour.svg';

export default function SideProjects(): Node {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production')
      window.analytics.page('Side projects');
  }, []);

  return (
    <BasicLayout
      title="Do you like shipping side project?"
      subtitle="You may be interested in that"
      ilustration={<Man />}
      ctaButton={
        <Button
          href="https://airtable.com/shrTs1XwY2Fz2nIUr"
          isTargetBlank
          iconFill="black"
          isRounded
        >
          Join beta users
        </Button>
      }
    >
      <div className="SideProjects__contentWrapper">
        <section className="SideProjects__content">
          <Title tag="h2" fontSize="m" isPrimary>
            What&#39;s it about
          </Title>
          I want to build a <strong>community</strong> around side-projects that
          will help you stay<strong> motivate</strong> and{' '}
          <strong>achieve projects&#39; goals.</strong>
          What&#39;s more thanks to that tool and the power of the community
          organizing your work will be easier and more satisfying.
        </section>
        <section className="SideProjects__content">
          <Title tag="h2" fontSize="m" isPrimary>
            How it&#39;ll work
          </Title>
          <article className="SideProjects__feature">
            <Title fontSize="s" tag="span">
              01. Create a project & provide basic information
            </Title>
            <p>
              Tell people about the tech stack you&#39;ve choose and estimate
              time you spend working on that project. It&#39;ll give the
              audience a glimpse how much are you involved.{' '}
            </p>
            <img className="SideProject__screen" src={BasicInfoImg} alt="" />
          </article>
          <article className="SideProjects__feature">
            <Title fontSize="s" tag="span">
              02. Tell people about a main goal you want to achieve by this
              project.
            </Title>
            <img className="SideProject__screen" src={MainGoalImg} alt="" />
          </article>
          <article className="SideProjects__feature">
            <Title fontSize="s" tag="span">
              03. Set up partial goals and keep your audience up-to-date.
            </Title>
            <p>
              thing. This will tell users what you are aiming for and help you
              stay organized and motivated. You can mark goals as achieved,
              update them, or create new one during work.
            </p>
            <img className="SideProject__screen" src={PartialGoalsImg} alt="" />
          </article>
          <article className="SideProjects__feature">
            <Title fontSize="s" tag="span">
              04. Publish posts & updates to the audience.
            </Title>
            <p>
              All the things you publish create project&#39;s history and
              roadmap. You can update your goals, write your thouths, share
              successes, and faileures. You can also ask about the advice other
              side-project makers. We are all have the same goal here - talking
              about cool side-projects so don&#39;t be afraid of sharing
              something!
            </p>
            <img className="SideProject__screen" src={PublishNewImg} alt="" />
          </article>
          <article className="SideProjects__feature">
            <Title fontSize="s" tag="span">
              05. Enjoy building with the community!
            </Title>
            <p>
              Let other developers know what&#39;s happening with your project,
              get feedback, audience, recognition, and motivation. Connect with
              other project makers and build another great thing.
            </p>
            <img className="SideProject__screen" src={FeedImg} alt="" />
          </article>
          <p>
            If you have any feedback, thoughts about the idea, or the execution,
            or just want to say hi please ping me on Twitter
            <a
              className="main-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/dominikilnicki"
            >
              @dominikilnicki.
            </a>
          </p>
        </section>
      </div>
      <section className="SideProjects__cta">
        <Title tag="span" fontSize="l" isMargin={false}>
          Sounds intersting to you?
        </Title>
        <p>Fill in a short form and sign up to the waiting list.</p>
        <Button
          isRounded
          href="https://airtable.com/shrTs1XwY2Fz2nIUr"
          isTargetBlank
          iconFill="black"
        >
          Join beta users
        </Button>

        <div className="SideProjects__spamPromise">
          <img
            className="SideProjects__profilePic"
            src={ProfilePicture}
            alt=""
          />
          <p className="SideProjects__spamText">
            No spam promised, I will be in a personal contact with you.
          </p>
        </div>
      </section>
    </BasicLayout>
  );
}
